<template>
    <o-modal @showModal="showModal" @close="closeModal">
        <template v-slot:header>
            Edit Tax & Service
        </template>
        <template v-slot:body>
            <div class="d-flex justify-content-center spinner-border text-primary spinner-position"
                v-if="page.isLoading">
            </div>
            <div v-if="errors.length">
                <div class="alert alert-danger">
                    <p>
                        <b>Please correct the following error(s):</b>
                        <ul>
                            <li v-for="(item, index) in errors" :key="index">{{ item }}</li>
                        </ul>
                    </p>
                </div>
            </div>
            <o-form autocomplete="off">
                <o-form-group title="Tax (%)" name="tax" class="text-start mb-2">
                    <span class="text-danger">*</span>
                    <o-input-text name="tax" v-model="item.tax" type="number" :required="true" min="0" />
                </o-form-group>
                <o-form-group title="Service (%)" name="service" class="text-start mb-2">
                    <span class="text-danger">*</span>
                    <o-input-text name="service" v-model="item.service" type="number" :required="true" min="0" />
                </o-form-group>
                <div class="d-flex d-inline-block">
                    <div class="me-2">
                        <o-button @click="saveDetail" :variant="'primary'" :white="'white'" type="button">Save</o-button>
                    </div>
                </div>
            </o-form>
        </template>
    </o-modal>
</template>

<script>
import { OModal, OForm, OFormGroup, OInputText, OButton } from '@/components/OmnihControl';

export default {
    name: 'TaxServiceDetail',
    components: {
        OModal,
        OForm,
        OFormGroup,
        OInputText,
        OButton
    },
    props: [
        'editedItem'
    ],
    data() {
        return {
            item: {
                tax: '',
                service: ''
            },
            errors: [],
            page: {
                isLoading: true
            }
        }
    },
    mounted() {
        if (this.editedItem) {
            this.item.tax = this.editedItem.tax ?? '';
            this.item.service = this.editedItem.service ?? '';
        }
        this.page.isLoading = false;
    },
    methods: {
        showModal() {},
        closeModal(e) {
            if (e && e.preventDefault) e.preventDefault();
            this.$emit('parentCloseModal');
        },
        saveDetail() {
            this.errors = [];
            if (this.item.tax === '' || isNaN(this.item.tax)) {
                this.errors.push('Tax is required and must be a number.');
            }
            if (this.item.service === '' || isNaN(this.item.service)) {
                this.errors.push('Service is required and must be a number.');
            }

            if (parseFloat(this.item.tax) + parseFloat(this.item.service) > 100) {
                this.errors.push('Warning - Tax + Service can’t be above 100%.');
            }

            if (this.errors.length === 0) {
                this.$emit('parentAddItem', { ...this.item });
            }
        }
    }
}
</script>